import { Component, OnInit } from '@angular/core';
import { ApplicationsDeveloperListComponent } from '../../lists/developer-applications-list/developer-applications-list.component';

@Component({
    selector: 'app-developer-applications',
    templateUrl: './developer-applications.component.html',
    styleUrls: ['./developer-applications.component.scss'],
    standalone: true,
    imports: [ApplicationsDeveloperListComponent]
})
export class DeveloperApplicationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
